/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Absence_Reason_OtherabsencesInputs */

const en_enum_absence_reason_otherabsences = /** @type {(inputs: Enum_Absence_Reason_OtherabsencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason Otherabsences`)
};

const de_enum_absence_reason_otherabsences = /** @type {(inputs: Enum_Absence_Reason_OtherabsencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grund Otherabsences`)
};

/**
* | output |
* | --- |
* | "Reason Otherabsences" |
*
* @param {Enum_Absence_Reason_OtherabsencesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_absence_reason_otherabsences = /** @type {((inputs?: Enum_Absence_Reason_OtherabsencesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Absence_Reason_OtherabsencesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_absence_reason_otherabsences(inputs)
	return de_enum_absence_reason_otherabsences(inputs)
});